import {isObject} from "@/assets/js/utils";
/**
 * 登录时在session保存登录信息
 * @param user
 */
export function sessionSetUserInfo(user){
  try {
    localStorage.setItem("Authorization",JSON.stringify(user));
  }catch (e) {
    console.log("sessionSetUserInfo 保存用户信息异常!");
  }

}
/**
 * 获取存储在 session 中的用户信息
 * @param key
 * @returns {*}
 */
export function sessionGetUserInfo(key) {
  let user = null;
  try {
    user = localStorage.getItem('Authorization');
    if(user) user = JSON.parse(user);
  }catch (e) {
    console.warn("sessionGetUserInfo 解析用户信息异常!");
  }
  if(!isObject(user)) user = {};
  if(!(typeof key === 'string' && key)) return user;
  return user[key];
}
/**
 * 退出登录时清除session登录信息
 */
export function sessionRemoveUserInfo (){
  localStorage.removeItem("Authorization");
}



// WEBPACK FOOTER //
// ./src/assets/js/utils.session.js